import { StripeExpressCheckoutElementConfirmEvent } from '@stripe/stripe-js'
import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'

export const extractApplePayFields = (
  event: StripeExpressCheckoutElementConfirmEvent,
  isShippingEnabled: boolean,
): Partial<Record<FieldSlugEnum, string>> => {
  const fields: Partial<Record<FieldSlugEnum, string>> = {}

  if (event.billingDetails?.email) {
    fields[FieldSlugEnum.Email] = event.billingDetails.email
  }

  if (event.billingDetails?.phone) {
    fields[FieldSlugEnum.PhoneNumber] = event.billingDetails.phone
  }

  if (event.billingDetails?.name) {
    const nameParts = event.billingDetails.name.trim().split(/\s+/)
    if (nameParts.length > 0) {
      fields[FieldSlugEnum.FirstName] = nameParts[0]
    }
    if (nameParts.length > 1) {
      fields[FieldSlugEnum.LastName] = nameParts.slice(1).join(' ')
    }
  }

  const address = isShippingEnabled
    ? event.shippingAddress || event.billingDetails?.address
    : event.billingDetails?.address

  if (address) {
    if ('country' in address) {
      fields[FieldSlugEnum.Country] = address.country
    }

    if ('state' in address) {
      fields[FieldSlugEnum.State] = address.state
    }

    if ('city' in address) {
      fields[FieldSlugEnum.City] = address.city
    }

    if ('postal_code' in address) {
      fields[FieldSlugEnum.Postcode] = address.postal_code
    }
  }

  return fields
}
